import React, { useState } from "react";
import { Form, InputGroup, Button } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";

const PasswordInput = ({
    value,
    onChange,
    placeholder = "Password",
    required = false,
    name,
}) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <InputGroup>
            <InputGroup.Text>
                <FontAwesomeIcon icon={faUnlockAlt} />
            </InputGroup.Text>
            <Form.Control
                type={showPassword ? "text" : "password"}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                name={name}
            />

            <Button
                variant="outline-light" className="btn-pil text-dark"
                // variant="outline-secondary"
                onClick={() => setShowPassword(!showPassword)}
            >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </Button>
        </InputGroup>
    );
};

export default PasswordInput;